var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8665 69.6654H48.1332C53.4537 69.6654 56.1139 69.6654 58.1461 68.6299C59.9336 67.7191 61.3869 66.2658 62.2977 64.4783C63.3332 62.4461 63.3332 59.7859 63.3332 54.4654V25.332L44.3332 6.33203H27.8665C22.546 6.33203 19.8858 6.33203 17.8536 7.36747C16.0661 8.27827 14.6127 9.73158 13.7019 11.5191C12.6665 13.5513 12.6665 16.2115 12.6665 21.532V54.4654C12.6665 59.7859 12.6665 62.4461 13.7019 64.4783C14.6127 66.2658 16.0661 67.7191 17.8536 68.6299C19.8858 69.6654 22.546 69.6654 27.8665 69.6654Z",
    fill: "#DEDEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3335 20.2656V7.18555V6.33203L63.3335 25.332L62.4802 25.3323H49.4002C47.6267 25.3323 46.7399 25.3323 46.0625 24.9871C45.4667 24.6835 44.9822 24.1991 44.6786 23.6032C44.3335 22.9258 44.3335 22.0391 44.3335 20.2656Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.22 36.5523H34.886V37.9743L27.83 47.3343H35.084V49.1523H25.022V47.7303L32.06 38.3703H25.22V36.5523ZM36.7614 36.5523H38.8314V49.1523H36.7614V36.5523ZM46.1063 36.5523C46.9703 36.5523 47.7323 36.7203 48.3923 37.0563C49.0523 37.3803 49.5623 37.8483 49.9223 38.4603C50.2823 39.0603 50.4623 39.7623 50.4623 40.5663C50.4623 41.3703 50.2823 42.0783 49.9223 42.6903C49.5623 43.2903 49.0523 43.7583 48.3923 44.0943C47.7323 44.4183 46.9703 44.5803 46.1063 44.5803H43.2083V49.1523H41.1383V36.5523H46.1063ZM43.2083 42.7803H45.9263C46.6703 42.7803 47.2583 42.5823 47.6903 42.1863C48.1343 41.7783 48.3563 41.2383 48.3563 40.5663C48.3563 39.8823 48.1403 39.3423 47.7083 38.9463C47.2763 38.5503 46.6883 38.3523 45.9443 38.3523H43.2083V42.7803Z",
    fill: "#00245C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.883a5e4a0c1189cccf711da0ec712e15.svg";
export { ForwardRef as ReactComponent };